import { createFileRoute } from '@tanstack/react-router';
import { BroadcastTestsRouteView } from '@/pages/workspaces/broadcasts/broadcast/routing';
import { CampaignExperimentsRoute } from './-route-wrappers';

function CampaignTestsRoute() {
  const { broadcastId } = Route.useParams();
  return (
    <BroadcastTestsRouteView
      broadcastId={broadcastId}
      experiments={<CampaignExperimentsRoute campaignId={broadcastId} campaignPath="broadcasts" />}
    />
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/tests/',
)({
  component: CampaignTestsRoute,
});
